// import config
//import { REMOTE_API_URL as LOANFORCE_API_URL } from '../../../util/config';
import { ZAP_URL as LOANFORCE_API_URL } from '../../../util/config';

async function sendFormData(
  formData,
  ads__referral_url__c,
  ads__landing_url__c
) {
  const formValuesFormatted = Object.keys(
    formData,
    ads__referral_url__c,
    ads__landing_url__c
  ).reduce(
    (c, k) => (
      (c[`${k.charAt(0).toLowerCase()}${k.slice(1, k.length)}`] =
        // eslint-disable-next-line no-sequences
        formData[k].value),
      c
    ),
    {}
  );

  const valuesToSend = {
    ...formValuesFormatted,
    ads__referral_url__c: ads__referral_url__c.current.value,
    ads__landing_url__c: ads__landing_url__c.current.value,
    LoanPurpose: 'purchase',
    CampaignName: 'Consumers-Corp Website',
    CampaignStatus: 'Active',
    Source: 'Corp Website-Condo',
    UserAccountName: 'apaule',
  };

  const apiResponse = await fetch(LOANFORCE_API_URL, {
    method: 'POST',
    mode: 'no-cors',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(valuesToSend),
  });

  return apiResponse;
}

export default sendFormData;
